import '@fortawesome/fontawesome-pro/css/fontawesome.css'
import '@fortawesome/fontawesome-pro/css/sharp-regular.css'
import '@fortawesome/fontawesome-pro/css/sharp-solid.css'
import '@fortawesome/fontawesome-pro/css/brands.css'
import './assets/style.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { client } from 'laravel-precognition-vue'
import filters from './filters'
import helpers from './helpers'
import gate from './gate'
import api from './api'
import modules from './modules'

import App from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'
import { useErrorStore } from './stores/error'

const app = createApp(App)
app.config.errorHandler = (err, vm, info) => {
  console.error(err)

  if (err.name !== 'AxiosError') {
    const errorStore = useErrorStore()
    errorStore.setHttpError({
      code: 9999,
      message: import.meta.env.DEV ? `${info}: ${err.message}` : 'Sorry, an error has occurred. Please try again later.'
    })
  }
}

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENV,
  sendDefaultPii: true,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.1,
  ignoreErrors: [
    'node is null',
    'instance is null',
    'Request aborted',
    'Request failed',
    'Network Error',
    'Precognition response',
    /^canceled$/
  ],
  integrations: [
    Sentry.browserTracingIntegration({
      router,
      routeLabel: 'path'
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: false,
      formTitle: 'Nurtur - Report a Bug',
      themeLight: {
        background: '#e8e8e8',
        accentBackground: '#309eaa',
        successColor: '#16a34a',
        errorColor: '#dc2626'
      },
      themeDark: {
        background: '#262626',
        accentBackground: '#309eaa',
        successColor: '#16a34a',
        errorColor: '#dc2626'
      }
    })
  ]
})

app.use(filters)
app.use(helpers)
app.config.globalProperties.$api = api
app.use(createPinia())
app.use(router)
app.use(modules)
app.use(gate)
client.use(api)

app.mount('#app')
